import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextField, Typography, Stack } from '@mui/material';

export default function SignatureOptions({ data, updateOptions }) {
  const { t } = useTranslation(['procedures']);
  return (
    <>
      <Typography variant="subtitle2" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
        {t('procedures:step_options.signature_canvas_options')}
      </Typography>
      <Stack spacing={2}>
        <TextField
          fullWidth
          type="number"
          label={t('procedures:form_labels.signature.canvas_width')}
          value={data.options?.canvas_width || 500}
          onChange={(e) => updateOptions({ canvas_width: parseInt(e.target.value) || 500 })}
        />
        <TextField
          fullWidth
          type="number"
          label={t('procedures:form_labels.signature.canvas_height')}
          value={data.options?.canvas_height || 200}
          onChange={(e) => updateOptions({ canvas_height: parseInt(e.target.value) || 200 })}
        />
        <TextField
          fullWidth
          label={t('procedures:form_labels.signature.pen_color')}
          type="color"
          value={data.options?.pen_color || '#000000'}
          onChange={(e) => updateOptions({ pen_color: e.target.value })}
        />
        <TextField
          fullWidth
          type="number"
          label={t('procedures:form_labels.signature.pen_width')}
          value={data.options?.pen_width || 2}
          onChange={(e) => updateOptions({ pen_width: parseInt(e.target.value) || 2 })}
        />
        <TextField
          fullWidth
          label={t('procedures:form_labels.signature.background_color')}
          type="color"
          value={data.options?.background_color || '#ffffff'}
          onChange={(e) => updateOptions({ background_color: e.target.value })}
        />
      </Stack>
    </>
  );
}
